<template>
  <el-dialog
    class="modal-select-stores"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="large"
    lock-scroll
    append-to-body
  >
    <div class="content">
      <div class="transfer-wrapper" @submit.prevent>
        <!-- 左侧 -->
        <div class="transfer__left">
          <div class="transfer-header__wrapper">
            <div class="filter-box">
              <div class="autocomplete-box">
                <el-autocomplete
                  v-model="filter.brandName"
                  :fetch-suggestions="$_handleSearchBrand"
                  :trigger-on-focus="false"
                  value-key="brandName"
                  placeholder="品牌名称"
                  @select="$_handleSelectBrand"
                ></el-autocomplete>
                <div
                  v-show="!searchBrandData.length && filter.brandName"
                  @click="$_clearSearchBrandData"
                  class="autocomplete-empty el-select-dropdown"
                >查无该品牌，请重新输入</div>
              </div>
              <el-input v-model="filter.storeName" placeholder="门店名称" class="filter-keyword__input"></el-input>
              <el-input v-model="filter.storeId" placeholder="门店ID" class="filter-keyword__input"></el-input>
              <el-input v-model="filter.shopId" placeholder="中台门店ID" class="filter-keyword__input"></el-input>
              <el-button @click="$_search" class="search__btn">查询</el-button>
              <el-button @click="$_reset" class="reset__btn">重置</el-button>
            </div>
          </div>

          <!-- 数据列表 -->
          <el-table
            class="table-list__box"
            ref="standbyList"
            :data="dataList"
            v-loading="isLoading"
            :height="535"
            @select="$_selectRow"
            @select-all="$_selectAll"
            stripe
            tooltip-effect="dark"
          >
            <el-table-column type="selection" width="50"></el-table-column>

            <el-table-column
              v-for="column in columns"
              :key="column.key"
              :prop="column.key"
              :label="column.label"
              :width="column.width"
              :resizable="false"
              show-overflow-tooltip
            ></el-table-column>

            <div class="table-list__empty small" slot="empty"></div>
          </el-table>

          <div class="pagination__wrapper">
            <cd-pagination
              ref="pager"
              :total="pagination.total"
              :currPage="pagination.pageNow"
              :pageSize="pagination.pageSize"
              @changepage="$_changeCurrent"
              @changesize="$_changeSize"
              :explainShow="false"
              @refresh="$_getStoreList"
            ></cd-pagination>
          </div>
        </div>
        <!-- 右侧 -->
        <div class="transfer__right">
          <div class="transfer-header__wrapper">
            <h3 style="padding-left:10px;">已选门店</h3>
            <el-button @click="$_clearSelecteds" class="clear__btn clear-all__btn">清除已选项</el-button>
          </div>

          <!-- 已选列表 -->
          <div class="table-list__wrapper">
            <el-table
              class="table-list__box selected-list"
              ref="selectedList"
              :data="selectedList"
              :height="573"
              stripe
              @selection-change="$_selectedChange"
              tooltip-effect="dark"
            >
              <el-table-column type="selection" align="center" width="50"></el-table-column>

              <el-table-column
                v-for="column in columns"
                :key="column.key"
                :prop="column.key"
                :label="column.label"
                :width="column.width"
                :resizable="false"
                show-overflow-tooltip
              ></el-table-column>

              <span class="table__empty-text" slot="empty">←请在左边栏目中选择门店</span>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">保存</el-button>
      <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
const columns = [
  { key: "brandName", label: "品牌名称", width: 140 },
  { key: "storeName", label: "门店名称", width: 110 },
  { key: "storeId", label: "门店ID", width: 110},
  { key: "shopId", label: "中台门店ID" },
];
export default {
  name: "select-stores",
  props: {
    title: { type: String, default: "" },
    platformKey: { type: String, default: "" },
    brandIds: { type: Array, default: ()=>[] },
    selecteds: { type: Array, default: [] }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      filter: {
        brandName: "",
        brandId: 0,
        storeName: "",
        storeId: "",
        shopId: ""
      },
      searchBrandData: [],
      columns,
      dataList: [],
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      },
      standBySelecteds: [], // 左侧可选择数据 已选择项
      selectedList: [], // 已选择项
      selectTheSelected: [] // 选择已选项
    };
  },
  watch: {
    "filter.brandName"(val) {
      if (val === "") {
        this.filter.brandId = 0;
      }
    }
  },
  methods: {
    // 下拉联想品牌
    $_handleSearchBrand(brandName, cb) {
      let postData = {
        platformKey: this.platformKey,
        brandName: brandName,
        pageNow: 1,
        pageSize: 9999
      };
      this.$service.post("getBrands", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          let brands = [];
          if (this.brandIds.length > 0) {
            brands = result.data.rows.filter(
              item => ~this.brandIds.indexOf(item.brandId)
            );
          } else {
            brands = result.data.rows.concat([]);
          }
          this.searchBrandData = [...brands];
          cb(brands);
        }
      });
    },
    // 选择品牌
    $_handleSelectBrand(item) {
      this.filter.brandName = item.brandName;
      this.filter.brandId = item.brandId;
    },
    $_clearSearchBrandData() {
      this.filter.brandName = "";
    },
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      let reg = /[^\d.]/g;
      if(this.filter.shopId && new RegExp(reg).test(this.filter.shopId)){
        $MessageBox.alert({
        content: `
            <div>中台门店id需填数字！</div>
          `,
        });
      }else {
        this.$_getStoreList();
      }
    },
    // 重置
    $_reset() {
      this.filter.brandName = "";
      this.filter.brandId = 0;
      this.filter.storeName = "";
      this.filter.storeId = "";
      this.filter.shopId = "";
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getStoreList();
    },
    // 查询门店列表
    $_getStoreList() {
      this.isLoading = true;
      const postData = {
        platformKey: this.platformKey,
        storeName: this.filter.storeName,
        brandName: this.filter.brandName,
        storeId: this.filter.storeId,
        shopId: this.filter.shopId || 0,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize
      };
      if (this.filter.brandId > 0) {
        Object.assign(postData, { brandId: this.filter.brandId });
      } else {
        Object.assign(postData, { brandIds: this.brandIds });
      }
      this.$service.post("getStores", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getStoreList();
    },
    // 切换每页条数
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getStoreList();
    },
    // 单选行
    $_selectRow(selection, row) {
      this.standBySelecteds = selection.concat();
      if (selection.some(item => item.storeId === row.storeId)) {
        // 选中
        let index = this.selectedList.findIndex(
          item => item.storeId === row.storeId
        );
        if (!~index) {
          this.selectedList.push(row);
        }
      } else {
        // 取消勾选
        let index = this.selectedList.findIndex(
          item => item.storeId === row.storeId
        );
        if (~index) {
          this.selectedList.splice(index, 1);
        }
      }
    },
    // 全选
    $_selectAll(selection) {
      this.standBySelecteds = selection.concat();
      if (selection.length > 0) {
        // 全选
        selection.forEach(row => {
          let index = this.selectedList.findIndex(
            item => item.storeId === row.storeId
          );
          if (!~index) {
            this.selectedList.push(row);
          }
        });
      } else {
        // 取消全选
        this.dataList.forEach(row => {
          let index = this.selectedList.findIndex(
            item => item.storeId === row.storeId
          );
          if (~index) {
            this.selectedList.splice(index, 1);
          }
        });
      }
    },
    // 右侧列表部分,
    $_selectedChange(selection) {
      this.selectTheSelected = selection.concat([]);
    },
    // 清除已选项
    $_clearSelecteds() {
      const self = this;
      self.selectTheSelected.forEach(item => {
        // 右侧数组删除已选项
        let index = self.selectedList.findIndex(
          row => row.storeId === item.storeId
        );
        if (~index) {
          self.selectedList.splice(index, 1);
        }
        // 判断左侧数据是否已勾选, 已勾选则取消
        let row = self.standBySelecteds.find(row => row.storeId === item.storeId);
        if (typeof row !== "undefined") {
          self.$refs.standbyList.toggleRowSelection(row);
        }
      });
      self.selectTheSelected.splice(0);
    },

    // 保存
    $_submit() {
      let stores = this.selectedList.concat([]);
      this.$emit("callback", stores);
      this.$_cancle();
    },
    // 取消
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  created() {
    if (this.selecteds.length) {
      this.selectedList = this.selecteds.concat([]);
    }
    this.$_getStoreList();
  },
  mounted() {
    this.visible = true;
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 14px;
}
.filter-box {
  position: relative;
  height: 60px;
  border: 1px solid #eee;
  background-color: #f5f6f7;
  padding: 0 14px;
  display: flex;
  justify-content: left;
  align-items: center;
  .autocomplete-box {
    display: inline-block;
    position: relative;
    width: 110px;
    margin-right: 10px;
    .autocomplete-empty {
      padding: 10px;
      margin: 0;
      color: #535353;
      top: 33px;
      width: 100%;
    }
  }
}
.transfer-wrapper {
  &::after {
    content: "";
    display: table;
    clear: both;
  }
  .transfer__left,
  .transfer__right {
    width: 600px;
    height: 635px;
    border: 1px solid #eee;
  }
  .transfer__left {
    float: left;
  }
  .transfer__right {
    float: right;
    .transfer-header__wrapper{
       border-bottom: 2px solid #eee;
    }
  }
  .transfer-header__wrapper {
    position: relative;
    border-bottom: 1px solid #eee;
    background-color: #f5f6f7;
    h3 {
      line-height: 58px;
      font-size: 14px;
      color: #535353;
    }
    .filter-wrapper,
    .clear-all__btn {
      position: absolute;
    }
    .filter-wrapper {
      top: 14px;
    }
    .filter-keyword__input {
      width: 110px;
      margin-right: 10px;
    }
    .clear-all__btn {
      top: 15px;
      right: 20px;
    }
  }
}

.table-list__box {
  margin-top: -1px;
  background-color: #f9f9f9;
}
</style>


